<script>
	import CustomCollapseCard from "src/components/CustomCollapseCard/CustomCollapseCard.svelte";
	import CaseInformationInput from "./CaseInformationInput.svelte";
	import CaseInformationDisplay from "./CaseInformationDisplay.svelte";

	export let zendeskTicketId;
	export let linkToCases;
	export let state = "view"; // possible values: "view", "edit"
	export let caseDetails = {};
	export let vehicleDetails = {};
</script>

<CustomCollapseCard
	customClass="mb-4"
	title="Case Information"
	isOpenDefault={true}
>
	{#if state === "create"}
		<CaseInformationInput {zendeskTicketId} {linkToCases} />
	{:else if state === "edit" || caseDetails.status === "Quoting"}
		<div class="p-0">
			<CaseInformationDisplay {caseDetails} {state} />
			<hr class="divider" />
			<CaseInformationInput {zendeskTicketId} {linkToCases} />
		</div>
	{:else if state === "view"}
		<CaseInformationDisplay {caseDetails} />
	{/if}
</CustomCollapseCard>
